module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "fm1"
  }, [_c('b', [_vm._v("Cheryl Minnick , M.Ed., Ed.D, CCMC, NCRW University of Montana – Academic Enrichment")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("(406) 243-4614")])]), _c('p', {
    staticClass: "txc"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "href": "mailto:cminnick@mso.umt.edu",
      "id": "AC9"
    }
  }, [_vm._v("cminnick@mso.umt.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Passionate, lively and engaging, Dr. Cheryl Minnick is career counselor/internship coordinator at the University of Montana with nearly thirty years’ experience in higher education, twenty of those in the area of career counseling. She holds both a masters and doctorate with specialization in career counseling. Trained by top industry experts, she is one of less than fifty Nationally Certified Resume Writers in the country. Cheryl is a guest instructor with Career Thought Leaders, a think tank for the now, new, and next in careers; teaches webinars for the Career Academy; and sits on the NRWA Certification Board for resume writing certification. Over a three-year period, she partnered with the Montana Department of Labor to train employment professionals statewide on best practices in resume creation, cover letter writing, and applicant tracking systems.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Cheryl is a certified Academies Career Management Coach whose career advice has been featured on AOLJobs, Voice America radio, CareerSparx and Resume Writer’s Digest; who has published career development research in the Journal of Academic Administration in Higher Education and The New Accountant; and who’s resumes and cover letters are published in books including, "), _c('i', [_vm._v("Motivated Resumes & LinkedIn Profiles, Modernize Your Resume: Get Noticed – Get Hired, Designing the Perfect Resume, How to Pop your Resume, Gallery of Best Cover Letters, The Twitter Job Search Guide")]), _vm._v(" and "), _c('i', [_vm._v("101 Job Seeking Tips for Recent College Grads")]), _vm._v(". If not on campus working with students, she can be found helping mid-level to senior-managers through her boutique career consulting business, The Paper Trail. Cheryl has successfully helped hundreds of students and professionals successfully navigate careers and achieve professional success.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ced4a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter07.vue
// module id = 84
// module chunks = 0